import { Component, Input,OnInit,HostListener,ViewChild,ElementRef} from '@angular/core';
import {commonService} from "../../service/common.service";;
import {HttpErrorResponse } from '@angular/common/http';
import {Globals } from '../../globals';
import { TestSeriesService } from '../../service/test-series.service';
import {ParamMap, Router, ActivatedRoute,Params } from '@angular/router';
import { Http, ResponseContentType } from '@angular/http';
import { FileSelectDirective,FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import { Location } from '@angular/common';

@Component({
  selector: 'app-evaluate-answer-sheet',
  templateUrl: './evaluate-answer-sheet.component.html',
  styleUrls: ['./evaluate-answer-sheet.component.css'],
  providers:[TestSeriesService]
})
export class EvaluateAnswerSheetComponent implements OnInit {
  userData:any;
  EvaluateAnswerSheetId:any;
  testData:any;
  path:any;
  studentUploadDocUrl:any;
  testPaperStructures:any;
  markBox:any;
  testAnswerUploadStructures:any
  comment:any;
  attachment:any;
  isevaluatebutton=false;
  progress:any=0;
  pdfUrl=false;
 

  constructor(private _location: Location,private http:Http,private commonService:commonService,private global : Globals,private TestSeriesService:TestSeriesService,private router: Router,private route: ActivatedRoute) {
   
    this.markBox={}; 
   

     this.commonService.profile.subscribe((data:any)=>{
       if(data){
       this.userData=data; 
       }else{
         this.userData={};
       } 
     });

    this.studentUploadDocUrl=this.global.tsAnsImageUrl;

    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
   }
   attachmentUrl =this.global.siteUrl+'file/upload?folder='+this.global.tsAnsFolder+'&mediaFor=studentEvaluation';
   uploader:FileUploader=new FileUploader({url:this.attachmentUrl,allowedMimeType: ['application/pdf','application/zip'],maxFileSize: 100*1024*1024});
  // fileExt: string = "pdf,zip";

  ngOnInit() {
    window.scrollTo(0, 0);
    this.route.params.subscribe((params: Params) => {
      if(params['id']){      
      this.EvaluateAnswerSheetId = parseInt(params['id']);
      if(isNaN(this.EvaluateAnswerSheetId)){
        this.EvaluateAnswerSheetId=0;
      } 
      }
    });
    this.getEvaluateAnswerSheet();
  }

  getEvaluateAnswerSheet(){
    let obj={}
    obj['userId']=(this.userData.id)?this.userData.id:0;
    obj['sheetId'] = this.EvaluateAnswerSheetId;

    
    this.TestSeriesService.getEvaluateAnswerSheet(obj).subscribe((data:any)=>{
          if(data.error==0){
           this.testData= data.results;
           this.testAnswerUploadStructures = data.results.testAnswerUploadStructures;
           this.testPaperStructures =this.getNestedChildren(this.testData.testPaper.testPaperStructures,0);
          // set data
           this.setansmark();
           this.comment=this.testData.comment;

          }

    },(error:HttpErrorResponse)=>{
     // this.msg="internal server error!";
    })
  }
  setansmark(){
    if(this.testAnswerUploadStructures.length>0){
      for(let keyData of this.testAnswerUploadStructures){
       this.markBox[keyData.paperStructureId] = keyData.mark;
      }

  }
  }
   getNestedChildren(arr, parent) {
    var out = []
    for(var i in arr) {
        if(arr[i].parent == parent) {
            var children = this.getNestedChildren(arr, arr[i].id)
            if(children.length) {
                arr[i].children = children
            }
            out.push(arr[i])
        }
    }
    return out
}
  checkFileextension(fileName){
    if(fileName){
     return this.commonService.checkFileextension(fileName);
    }
  }




  getExt(filename)
  {
      var ext = filename.split('.').pop();
      if(ext == filename) return "";
      return ext;
  }
  downloadFile(testData,downloadtype){

    if(downloadtype=="student"){
      var filename = testData.fileName;
    }else{
      var filename = testData.facultyFileName;
    }
    var ext  =  this.getExt(filename);
    var url=this.studentUploadDocUrl + filename;
    return this.http.get(url,{
      responseType: ResponseContentType.Blob,
    })
    .map(res => {
      return {
        filename: filename,
        data: res.blob()
      };
    }).subscribe(res => {
        var url = window.URL.createObjectURL(res.data);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
      //  a.download = testData.student.firstName+"_"+testData.student.lastName+res.filename;
      a.download = testData.student.firstName.toLowerCase()+"_"+testData.studentId+"_"+testData.testPaperId+"."+ext;
      a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
      }, error => {
        console.log('download error:', JSON.stringify(error));
             if(error.status="404"){
                    alert('Something went wrong. Please try to latter.');
             }
      }, () => {
       // console.log('Completed file download.')
      });
  }

  AddEvalution(contentForm,markBox){
    this.isevaluatebutton=true;
  // add data when form submit
     let formData = {};
     formData['comment']=contentForm.value.comment;
     formData['evalutionMark']=markBox;
     formData['SheetId']=this.EvaluateAnswerSheetId;
     formData['studentId']=  this.testData.studentId;
     formData['testPaperId']=this.testData.testPaperId;
     formData['evaluatedAnswerdoc']=this.attachment;

            this.TestSeriesService.addEvalution(formData).subscribe((data : any)=>{
                if(data.error==0){ 
                  this.isevaluatebutton=false;
                 localStorage.setItem('isSuccess','Yes');
                  localStorage.setItem('msg','Paper evaluation added successfully.');
                  this.router.navigate(['/user/timeline']);
                }else{
                  this.isevaluatebutton=false;
                  if(data.message=="Failed to authenticate token."){
                    this.router.navigate(['/admin']);
                  }else{
                    this.isevaluatebutton=false;
                 // this.msg = data.message;
                  //this.formvailidation = true;
                  }
                }
            },
          (error : HttpErrorResponse)=>{
            this.isevaluatebutton=false;
            //this.isError = true;
            //this.msg="internal server error!";
          });
   
  
  
}

// add evelution doc


ngAfterViewInit() {
  this.uploader.onAfterAddingFile = (item => {
    item.withCredentials = false;
 });
}
onFileChanged(event) {
  this.uploader.uploadAll();
  this.progress=1;
 }
 private sleep (time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
  //console.log("Success");
    //console.log(item); 
    let data = JSON.parse(response); //success server response

      if(data.error==0){
        this.progress=0;
       // console.log("set Ids");
        //console.log(data.result.id);

        this.attachment = data.result.id;
        //this.attachmentdetail.push(data.result);
        //console.log(this.attachment);
      }else{

       alert("There is some technical problem. Please try again");
        this.uploader.clearQueue();
      }
     
  }

  onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
      let error = JSON.parse(response); //error server response
      alert("There is some technical problem. Please try again");
      this.uploader.clearQueue();
  }

  deleteFile(objdata){

      if(confirm("Do you want to delete ?")){ 
        var obj={};
        obj['sheetId']=objdata.id;
        this.TestSeriesService.delfacultyUploadedDoc(obj).subscribe((data:any)=>{
          if(data.error==0){
            try{
              this.testData['facultyFileName']='';
            }catch(e){
              console.log(e);
            }            
          }
        },(error:HttpErrorResponse)=>{
          //this.msg="internal server error!";
          alert("There is some technical problem. Please try again");
        })
    }
}
totalMark(objMark){
  let mark=0;
    for(let key in objMark){
            if(!isNaN(parseInt(objMark[key]))){
              mark = mark+parseInt(objMark[key]);
            }    
    }
  return mark;
}

keyPress(event: any) {
  const pattern = /[0-9\+\-\ ]/;
// console.log(event);
  let inputChar = String.fromCharCode(event.charCode);
  if (event.keyCode != 8 && !pattern.test(inputChar)) {
    event.preventDefault();
   // console.log('not right');
  }
}
backClicked() {
  this._location.back();
}

needLogin() {
  this.commonService.setLoginBox(true);
}


OpenQuestionWindow(id) {
 // id = 13;
  if (Object.keys(this.userData).length == 0) {
    this.needLogin();
    return false;
  }
  
  /*if (this.pdfUrl) {
    alert("PDF is already running in a new window.");
    return;
  }*/
  //this.router.navigate(['/']);
  var randomnumber = Math.floor((Math.random() * 100) + 1);
  var child = window.open('https://mts.nextias.com/viewer/web/indexadmin.php?v=3-0-0-' +id+ '&token=' + btoa(this.userData.id) + '&type=reviewstudentsheet', "_blank", 'PopUp' + randomnumber + ',scrollbars=1,menubar=0,resizable=1,width=1300,height=650');
  this.pdfUrl = true;
  //console.log(this.child);
  var winClosed = setInterval(function (this) {
    if (child.closed) {
      this.pdfUrl = false;
      clearInterval(winClosed);
      //alert('closed');  

      setTimeout(() => { 
        document.getElementById("closeChildWindow").click();
      this.pdfUrl = false;
      }, 1000);
    }
  }, 1000);
  //console.log(this.quizUrl);
}

// ON CLOSE OF QUIZ WINDOW REDIRECT TO DIFFRENT PAGE
closewindow() {
  this.pdfUrl = false;
  this.getEvaluateAnswerSheet();
}

}




// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/evaluate-answer-sheet/evaluate-answer-sheet.component.ts